module.exports = __webpack_public_path__ + "static/media/YM34_2.8ff5a0bf.jpg";